import { Chart } from "@/ui/organisms/Chart/Chart";
import { GroupedCategoryAxis, MoneyAxis } from "@/ui/organisms/Chart/Axis";
import {
    filterNullValuesFromChartData,
    formatCurrency,
    formatTooltipData,
} from "./utils/filterChartData";

export function DisbursementsAndRepayments({
    isCondensed,
    data,
}: {
    isCondensed?: boolean;
    data?: any;
}) {
    const filteredData = filterNullValuesFromChartData(data || []);
    if (filteredData.length === 0) {
        return null;
    }

    return (
        <Chart
            title="Disbursements and Cash Repayments"
            description="Following significant debt disbursements, the company has generally met recurring interest and amortization payments, but reliance on new large financings and irregular repayments reflect material refinancing and liquidity risk."
            isCondensed={isCondensed}
            options={{
                data: filteredData,
                tooltip: {
                    mode: "single",
                },
                series: [
                    {
                        type: "bar",
                        xKey: "month",
                        yKey: "disbursement",
                        yName: "Disbursement (Remittance Report)",
                        stacked: true,
                        tooltip: {
                            renderer: (params) => {
                                const datum = params.datum;
                                const month = `${datum.month[1]} ${datum.month[0]}`;
                                return {
                                    heading: `${month}`,
                                    title: "Disbursement (Remittance Report)",
                                    data: formatTooltipData([
                                        {
                                            label: "Disbursement",
                                            value: formatCurrency(
                                                datum.disbursement,
                                            ),
                                        },
                                    ]),
                                };
                            },
                        },
                    },
                    {
                        type: "bar",
                        xKey: "month",
                        yKey: "amortization",
                        yName: "Amortization (Remittance Report)",
                        stacked: true,
                        tooltip: {
                            renderer: (params) => {
                                const datum = params.datum;
                                const month = `${datum.month[1]} ${datum.month[0]}`;
                                return {
                                    heading: `${month}`,
                                    title: "Amortization",
                                    data: formatTooltipData([
                                        {
                                            label: "Amortization",
                                            value: formatCurrency(
                                                datum.amortization,
                                            ),
                                        },
                                    ]),
                                };
                            },
                        },
                    },
                    {
                        type: "bar",
                        xKey: "month",
                        yKey: "interestAndFeesCash",
                        yName: "The Cash Portion of Interest and Fees (Remittance Report)",
                        stacked: true,
                        tooltip: {
                            renderer: (params) => {
                                const datum = params.datum;
                                const month = `${datum.month[1]} ${datum.month[0]}`;
                                return {
                                    heading: `${month}`,
                                    title: "Interest and Fees Cash",
                                    data: formatTooltipData([
                                        {
                                            label: "Interest & Fees Cash",
                                            value: formatCurrency(
                                                datum.interestAndFeesCash,
                                            ),
                                        },
                                    ]),
                                };
                            },
                        },
                    },
                ],
                axes: [
                    GroupedCategoryAxis.doubleDepth,
                    {
                        ...MoneyAxis,
                        keys: [
                            "disbursement",
                            "amortization",
                            "interestAndFeesCash",
                        ],
                    },
                ],
            }}
        />
    );
}
